import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  subjectsRoute: {
    id: 'omnibar.routes.value.subjects',
    defaultMessage: 'subjects',
  },
  subjectsRouteDisplay: {
    id: 'omnibar.routes.display.subjects',
    defaultMessage: 'Jump to: Subjects',
  },
  surveysRoute: {
    id: 'omnibar.routes.value.surveys',
    defaultMessage: 'surveys',
  },
  surveysRouteDisplay: {
    id: 'omnibar.routes.display.surveys',
    defaultMessage: 'Jump to: Surveys',
  },
  insightsRoute: {
    id: 'omnibar.routes.value.insights',
    defaultMessage: 'insights',
  },
  insightsRouteDisplay: {
    id: 'omnibar.routes.display.insights',
    defaultMessage: 'Jump to: Insights',
  },
  cohortsRoute: {
    id: 'omnibar.routes.value.cohorts',
    defaultMessage: 'cohorts',
  },
  cohortsRouteDisplay: {
    id: 'omnibar.routes.display.cohorts',
    defaultMessage: 'Jump to: Cohorts',
  },
  tasksRoute: {
    id: 'omnibar.routes.value.tasks',
    defaultMessage: 'tasks',
  },
  tasksRouteDisplay: {
    id: 'omnibar.routes.display.tasks',
    defaultMessage: 'Jump to: Tasks',
  },
  filesRoute: {
    id: 'omnibar.routes.value.files',
    defaultMessage: 'files',
  },
  filesRouteDisplay: {
    id: 'omnibar.routes.display.files',
    defaultMessage: 'Jump to: Files',
  },
  knowledgeRoute: {
    id: 'omnibar.routes.value.knowledge',
    defaultMessage: 'knowledge',
  },
  knowledgeRouteDisplay: {
    id: 'omnibar.routes.display.knowledge',
    defaultMessage: 'Jump to: Knowledge',
  },
  addDataRoute: {
    id: 'omnibar.routes.value.addData',
    defaultMessage: 'add data, import, bulk import',
  },
  addDataRouteDisplay: {
    id: 'omnibar.routes.display.addData',
    defaultMessage: 'Jump to: Add Data',
  },
  genomicsRoute: {
    id: 'omnibar.routes.value.genomics',
    defaultMessage: 'genomics',
  },
  genomicsRouteDisplay: {
    id: 'omnibar.routes.display.genomics',
    defaultMessage: 'Jump to: Genomics',
  },
  consentRoute: {
    id: 'omnibar.routes.value.consent',
    defaultMessage: 'consent',
  },
  consentRouteDisplay: {
    id: 'omnibar.routes.display.consent',
    defaultMessage: 'Jump to: Consent',
  },
  layoutRoute: {
    id: 'omnibar.routes.value.layout',
    defaultMessage: 'layout',
  },
  layoutRouteDisplay: {
    id: 'omnibar.routes.display.layout',
    defaultMessage: 'Jump to: {layout}',
  },
  close: {
    id: 'omnibar.actions.close',
    defaultMessage: 'Close',
  },
  navigateToSubject: {
    id: 'omnibar.routes.display.navigateToSubject',
    defaultMessage: 'Jump to: {subject}',
  },
});
